import React from "react";
import { SectionTitle } from "@/components/Section";
import { DISCLAIMER, CONTACT } from "@/lib/constants";

const SECTIONS = [
  { h: "1. Acceptance of Terms", p: "By accessing and using UPSC With Arpita, you agree to be bound by these Terms of Use. If you do not agree, please do not use this platform." },
  { h: "2. Educational Purpose", p: "All content on this platform, including Revision Kits and courses, is provided for educational and informational purposes only. While we strive for accuracy, we do not guarantee that the content is free of errors or fully up to date with the latest UPSC syllabus or notifications." },
  { h: "3. Free Account & Access", p: "Revision Kits are provided free of charge and require a free account to access. You agree to provide accurate registration information and to keep your login credentials confidential. You are responsible for all activity under your account." },
  { h: "4. Intellectual Property", p: "All Revision Kits, notes, course material, and branding are the intellectual property of UPSC With Arpita. You may use the material for your personal preparation only. Redistribution, resale, or public sharing of any material without written permission is strictly prohibited." },
  { h: "5. Paid Courses & Payments", p: "Paid courses are subject to their respective pricing. Payments are processed securely through Razorpay. Refunds, if any, are governed by the specific course's refund policy communicated at the time of enrolment." },
  { h: "6. No Affiliation with UPSC", p: DISCLAIMER },
  { h: "7. Limitation of Liability", p: "We are not liable for any direct or indirect loss arising from the use of this platform or reliance on its content, including exam outcomes. Your preparation and results remain your own responsibility." },
  { h: "8. Contact", p: "For any questions regarding these Terms, contact us at " + CONTACT.email + "." },
];

export default function Terms() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <SectionTitle sub="Please read these terms carefully" testId="terms-title">Terms of Use</SectionTitle>
      <div className="gov-card p-6">
        <p className="text-sm text-gray-600">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
        <div className="mt-4 space-y-5">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h3 className="font-serif text-base font-bold text-[#0B2545]">{s.h}</h3>
              <p className="mt-1 text-sm leading-relaxed text-gray-700">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
